(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
let parameters = {};
if (location.search.length) {
  let keyValue = "";
  let couples = location.search.substr(1).split('&');
  for (let i = 0; i < couples.length; i++) {
    keyValue = couples[i].split('=');
    if (keyValue.length > 1) {
      parameters[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
    }
  }
}
const selectElement = document.querySelector("#sort_by");
selectElement.addEventListener("change", function(event) {
  parameters.sort_by = event.target.value;
  const url = Object.keys(parameters).map(function(key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key])
  }).join('&');
  location.search = url;
});

  } catch(e) { console.error(e); }
})();

})();
